import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <span className="font-mono-ind text-xs uppercase tracking-[0.3em] text-[#FF3B30]">
        {children}
    </span>
);
